
function capitalize(string) {
  if (typeof string !== "string") return "";
  string = string.toLowerCase();

  return string.charAt(0).toUpperCase() + string.slice(1);
}

export default capitalize;
